const loadScript = (url, callback) => {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    if (script.readyState) {
      // IE
      script.onreadystatechange = function() {
        if (script.readyState === 'loaded' || script.readyState === 'complete') {
          script.onreadystatechange = null;
          callback();
        }
      };
    } // Others
    else {
      script.onload = function() {
        callback();
      };
    }
    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
  };
  
  export default function loadMultipleScripts(urls, final_callback, index = 0) {
    if (typeof urls[index + 1] === 'undefined') {
      loadScript(urls[index], final_callback);
    } else {
      loadScript(urls[index], () => {
        loadMultipleScripts(urls, final_callback, index + 1);
      });
    }
  }
  